// extracted by mini-css-extract-plugin
export default {"table":"table_table__Wf2dL","cellWithInput":"table_cellWithInput__TghpH"};